import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.incident-vorlage-kopieren-admin';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentVorlageKopierenAdminEffects {

    IncidentVorlageKopierenAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_INCIDENT_VORLAGE_KOPIEREN_ADMIN),
        mergeMap((x: ac.PostIncidentVorlageKopierenAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postIncidentVorlageKopierenAdmin(x.incidentVorlageRequest).pipe(
                map((result: any) => {
                    return new ac.PostIncidentVorlageKopierenAdminErfolgreichAction(result, x.incidentVorlageRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostIncidentVorlageKopierenAdminFehlerAction(error, x.incidentVorlageRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentVorlageCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentVorlageCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentVorlageCommandService);
        }
        return this.service;
    }
}
